<template>
  <div class="blocked-wrap">
    <p class="title">页面无法访问</p>
    <p class="desc">请从活动推广链接进入</p>
  </div>
</template>

<script>
export default {
  name: 'BlockedPage'
}
</script>

<style scoped>
.blocked-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #666;
}
.title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.desc {
  margin: 0;
  font-size: 14px;
}
</style>
